import { connect } from 'react-redux';
import compose from 'recompose/compose';
import withState from 'recompose/withState';
import lifecycle from 'recompose/lifecycle';
import groupBy from 'lodash/groupBy';
import values from 'lodash/values';

import ActivitiesTabItem from './ActivitiesTabItem';

const getCoachActivitiesWithGroups = (coach, clubActivities) => {
  const activitiesList = Object.values(clubActivities);

  // pour chaque activité, on regarde si son id est dans le tableau d'activité du coach
  const listActivitiesFromCoach = activitiesList.filter(activity => coach.activityIds.includes(activity.id.toString()));

  // on ressort un objet ou chaque activité est dans un tableau correspondant à son groupe
  // cela permet de gérer les cas où l'activité n'a pas de groupes
  const groupsWithActivitiesFromCoach = groupBy(listActivitiesFromCoach, 'activityGroup.name');

  const coachGroups = values(groupsWithActivitiesFromCoach).map(activities => {
    const group = activities[0].activityGroup
      ? {
          id: activities[0].activityGroup.id,
          name: activities[0].activityGroup.name,
          colorCode: activities[0].activityGroup.colorCode
        }
      : {
          id: 0,
          name: 'OTHER',
          colorCode: '#7e7e7e'
        };

    return {
      group,
      activities
    };
  });

  return coachGroups;
};

const mapStateToProps = ({ entities }) => ({
  clubActivities: entities.activities
});

function componentWillMount() {
  const { clubActivities, coach, setCoachGroups } = this.props;
  if (coach) {
    const getCoachGroups = getCoachActivitiesWithGroups(coach, clubActivities);
    setCoachGroups(getCoachGroups);
  }
}

function componentWillReceiveProps(nextProps) {
  const { coach: nextCoach } = nextProps;
  const { clubActivities, coach, setCoachGroups } = this.props;
  if (nextCoach && nextCoach !== coach) {
    const getCoachGroups = getCoachActivitiesWithGroups(nextCoach, clubActivities);
    setCoachGroups(getCoachGroups);
  }
}

export default compose(
  connect(mapStateToProps),
  withState('coachGroups', 'setCoachGroups', []),
  lifecycle({ componentWillMount, componentWillReceiveProps })
)(ActivitiesTabItem);



// WEBPACK FOOTER //
// ./src/components/CoachPanel/Tab/ActivitiesTabItem/ActivitiesTabItemContainer.jsx